<template>
  <div class="wareRecordDetailPage">
    <div class="main_content">
      <div class="tit">操作记录</div>
      <div class="goods_desciption">
        <p class="txt1 fontSize-blueColor-xll">商品ID：{{ detail.cm.id }}</p>
        <p class="txt2 fontSize-blueColor-xll">商品名称：</p>
        <p class="txt3">{{ detail.cm.commodityname }}</p>
        <p class="txt3">{{ detail.cm.commodityname_e }}</p>
        <p class="txt3">{{ detail.cm.commodityname_y }}</p>
        <p class="txt3">{{ detail.cm.commodityname_m }}</p>
        <p class="txt3">{{ detail.cm.commodityname_t }}</p>
        <p class="txt1 fontSize-blueColor-xll">
          SKU采购编码：{{ detail.cm.sku }}
        </p>
        <!-- <p class="fontSize-blueColor-xll">ISBN编码： {{ detail.cm.ISBN }}</p> -->
      </div>
      <div class="goods_other_desciption">
        <div class="good_item">
          <h3>记录类型：</h3>
          <p>{{ detail.actnamestr }}</p>
        </div>
        <div class="good_item">
          <h3>变动原因：</h3>
          <p>{{ detail.actreasonidstr }}</p>
        </div>
        <div class="good_item">
          <h3>入库数量：</h3>
          <p>{{ detail.num }}</p>
        </div>
        <div class="good_item">
          <h3>入库商品属性：</h3>
          <p>{{ detail.ams_shop_commodity_attrid_str }}</p>
        </div>
        <div class="good_item">
          <h3>入库商品属性值：</h3>
          <p>{{ detail.ams_shop_commodity_attr_value_str }}</p>
        </div>
        <!-- <div class="good_item">
          <h3>入库订单信息记录：</h3>
          <p>（采购订单）{{ detail.actname }}</p>
        </div> -->
        <div class="good_item">
          <h3>入库收货物流类型记录：</h3>
          <p>{{ detail.wsid }}</p>
        </div>
        <div class="good_item">
          <h3>入库收货物流单号记录：</h3>
          <p>{{ detail.wsno }}</p>
        </div>
        <div class="good_item">
          <h3>备注信息记录：</h3>
          <p>{{ detail.reason }}</p>
        </div>
        <div class="good_item">
          <h3>入库位置：</h3>
          <p v-if="detail.whid1_str">{{ detail.whid1_str }}，</p>
          <p v-if="detail.whid2_str">{{ detail.whid2_str }}，</p>
          <p v-if="detail.whid3_str">{{ detail.whid3_str }}，</p>
          <p v-if="detail.whid4_str">{{ detail.whid4_str }}，</p>
        </div>
        
        <div class="good_item">
          <h3>入库商品批次记录：</h3>
          <p>{{ detail.makerno }}</p>
        </div>
        <div class="good_item">
          <h3>入库商品生产商记录：</h3>
          <p>{{ detail.makername_str }}</p>
        </div>
        <div class="good_item">
          <h3>操作日期：</h3>
          <p>{{ detail.createdate | formatDate }}</p>
        </div>
        <div class="good_item">
          <h3>操作人员：</h3>
          <p>{{ detail.userman }}</p>
        </div>
      </div>


      <!-- <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div> -->
      <div class="fixd_button_btm">
      <div class="item" @click="handleReturn">返回</div>
    </div>
    </div>
  </div>
</template>

<script>
import storage from "../../utils/storage";

export default {
  name: "wRecordDetail",
  data() {
    return {
      detail: "",
    };
  },
   filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
  created() {
    this.detail = storage.get("DETAILITEM");
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.wareRecordDetailPage {
  .tit {
    text-align: center;
    font-size: 38px;
    padding: 80px 0;
  }
  .main_content {
    padding: 0 64px 348px;
  }
  .goods_desciption .txt3 {
    font-size: 32px;
  }
}
</style>